import { render } from "./ModalReferences.vue?vue&type=template&id=c2a64aae&scoped=true"
import script from "./ModalReferences.vue?vue&type=script&lang=js"
export * from "./ModalReferences.vue?vue&type=script&lang=js"

import "./ModalReferences.vue?vue&type=style&index=0&id=c2a64aae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a64aae"]])

export default __exports__